import {
  Button,
  CloseButton,
  Flex,
  Heading,
  IconDownloadLine,
  Modal,
  Text,
} from "@instructure/ui";
import { useContext, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";
import { FeatureContext } from "../../utils/Context";
import { buildCurriculumMapRows } from "../../utils/CurriculumMapExport";
import { downloadCSVTemplate } from "../../utils/DownloadCSVTemplate";

const CURRENT = "current";
const BOTH = "both";

const headers = [
  "map_tense",
  "subject_code",
  "offering_code",
  "origin_context",
  "origin_id",
  "origin_name",
  "origin_statement",
  "destination_context",
  "destination_id",
  "destination_name",
  "destination_statement",
  "present_or_upcoming",
  "degrees_of_learning",
  "mapping_state",
];

const DownloadModal = ({
  open,
  setOpen,
  rows,
  cols,
  futureMap,
  badgeMappings,
}) => {
  const { t } = useTranslation();
  const features = useContext(FeatureContext);
  const setLoSyncFlag =
    features.find((f) => f.name === "ilo_plo_sync_flag")?.value === "TRUE";

  const setBadgingFlag =
    features.find((f) => f.name === "badging_flag")?.value === "TRUE";

  useEffect(() => {
    if (setBadgingFlag && !headers.includes("open_badge_id")) {
      headers.push("open_badge_id");
    }
    if (setBadgingFlag && !headers.includes("issuer_open_badge_id")) {
      headers.push("issuer_open_badge_id");
    }
    if (setLoSyncFlag && !headers.includes("set_lo_sync")) {
      headers.push("set_lo_sync");
    }
  }, [setLoSyncFlag]);

  const handleCurrent = () => {
    const data = buildCurriculumMapRows(rows, cols, CURRENT, {
      badgeMappings,
      setLoSyncFlag,
      futureMap,
      headers,
    });
    downloadCSVTemplate("curriculum_map.csv", headers, data);
  };

  const handleCurrentFuture = () => {
    const data = buildCurriculumMapRows(rows, cols, BOTH, {
      badgeMappings,
      setLoSyncFlag,
      futureMap,
      headers,
    });
    downloadCSVTemplate("curriculum_map.csv", headers, data);
  };

  return (
    <Modal open={open} label={t("global.dragFile")}>
      <Modal.Header>
        <Heading level="h2" as="h1">
          {t("manageMap.downloadCurriculumMap")}
        </Heading>
        <CloseButton
          placement="end"
          offset="medium"
          screenReaderLabel={t("global.close")}
          onClick={() => setOpen(false)}
        />
      </Modal.Header>
      <Modal.Body>
        <Text as="div">
          <Trans i18nKey="manageMap.currentText1">
            You may download your program&apos;s curriculum map below. A data
            dictionary for the file contents can be downloaded
            <a href="/currentMapDataDictionary.txt" download>
              here
            </a>
            .
          </Trans>
        </Text>
        <br />
        <Text as="div">
          <Text>{t("manageMap.currentText2")}</Text>
        </Text>
        <br />
        <Flex gap="small">
          <Flex.Item>
            <Button
              color="primary"
              renderIcon={IconDownloadLine}
              onClick={handleCurrent}
              disabled={rows.length === 0}
            >
              {t("manageMap.currentMap")}
            </Button>
          </Flex.Item>
          <Flex.Item>
            <Button
              color="primary"
              renderIcon={IconDownloadLine}
              onClick={handleCurrentFuture}
              disabled={rows.length === 0}
            >
              {t("manageMap.currentAndFutureMap")}
            </Button>
          </Flex.Item>
        </Flex>
      </Modal.Body>
      <Modal.Footer>
        <Button margin="0 small 0 0" onClick={() => setOpen(false)}>
          {t("global.close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DownloadModal;
